import { CurrentFlow } from 'enums/CurrentFlow';

export const FLOW_ARG_TO_CURRENT_FLOW: Record<string, CurrentFlow> = {
  checkup: CurrentFlow.FinancialCheckup,
  card: CurrentFlow.Card,
};
